'use client';

import { token } from '@terra/ui-styled-system';
import { InformationCircleIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Alert } from '../../../components/alert';
import { BodyDefault } from '../../../components/typography';

export const ApiDocumentationRequiredAlert = () => {
  const t = useTranslations(
    'designSystem.documentsReports.apiDocumentationRequired',
  );

  return (
    <Alert.Root
      px="4"
      py="2"
      borderColor="border.vulnerability.cold"
      background="bg.vulnerability.cold"
      gap={2.5}
    >
      <Alert.Icon asChild>
        <InformationCircleIcon
          size={20}
          color={token('colors.fg.vulnerability.cold')}
        />
      </Alert.Icon>
      <Alert.Content>
        <Alert.Title>{t('title')}</Alert.Title>
        <Alert.Description>
          <BodyDefault color="fg.neutral.default">
            {t('description')}
          </BodyDefault>
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
};
